(function() {
  function main() {
    const modal = document.querySelector('.js-language-switcher-modal');
    const openers = document.querySelectorAll('.js-langauge-switcher-open');
    const closers = document.querySelectorAll('.js-langauge-switcher-close');

    for (const opener of openers) {
      opener.addEventListener('click', () => {
        modal.classList.toggle('is-active');
      });
    }

    for (const closer of closers) {
      closer.addEventListener('click', () => {
        modal.classList.remove('is-active');
      });
    }

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        modal.classList.remove('is-active');
      }
    });
  }

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    main();
  } else {
    document.addEventListener('DOMContentLoaded', main);
  }
})();
